import React from 'react';

import AsideLeft from '../../components/Asides/AsideLeft';
import AsideRight from '../../components/Asides/AsideRight';
import Footer from '../../components/Footer';
import Header from '../../components/Header';

const MainLayout = props => {
  return (
    <>
      <Header {...props} />      
    <section class="sites-section-1">
            <div class="container-fluid">
                <div class="row">

                    <AsideLeft />      
                        {props.children}
                    <AsideRight />
      
                </div>
            </div>
    </section>
      <Footer />
    </>
  );
};

export default MainLayout;
